import type { Map } from 'maplibre-gl';

/** The live MapLibre map, set by Map.svelte once loaded; null-check before use. */
export const mapInstanceStore = $state({ map: null as Map | null });
